import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AdminAnnouncementListDto,
  AnnouncementDto,
  CreateAnnouncementRequest,
  UpdateAnnouncementRequest,
} from '../models/announcement.models';
import { ApiService } from './api.service';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  errors: string[];
}

@Injectable({ providedIn: 'root' })
export class AnnouncementService extends ApiService {
  private url = environment.apiUrl + '/api/announcements';
  private adminUrl = environment.apiUrl + '/api/superadmin/announcements';

  getAnnouncements(): Observable<ApiResponse<AnnouncementDto[]>> {
    return this.http.get<ApiResponse<AnnouncementDto[]>>(this.url);
  }

  getAdminAnnouncements(
    page = 1,
    pageSize = 20,
  ): Observable<ApiResponse<AdminAnnouncementListDto>> {
    return this.http.get<ApiResponse<AdminAnnouncementListDto>>(
      `${this.adminUrl}?page=${page}&pageSize=${pageSize}`,
    );
  }

  create(req: CreateAnnouncementRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.adminUrl, req);
  }

  update(id: string, req: UpdateAnnouncementRequest): Observable<ApiResponse<null>> {
    return this.http.put<ApiResponse<null>>(`${this.adminUrl}/${id}`, req);
  }

  toggle(id: string, isActive: boolean): Observable<ApiResponse<null>> {
    return this.http.patch<ApiResponse<null>>(
      `${this.adminUrl}/${id}/toggle?isActive=${isActive}`,
      {},
    );
  }

  delete(id: string): Observable<ApiResponse<null>> {
    return this.http.delete<ApiResponse<null>>(`${this.adminUrl}/${id}`);
  }
}
